var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center", width: "95%" } },
    [
      _vm.icon && !_vm.iconUrl
        ? _c("div", { staticClass: "srcImg" })
        : _vm._e(),
      _vm.iconUrl
        ? _c("img", {
            staticClass: "srcImg",
            attrs: { src: _vm.iconUrl, alt: "" }
          })
        : _vm._e(),
      _vm.ismenu || _vm.isMenuTitle
        ? _c(
            "span",
            {
              ref: "menu",
              staticClass: "line menutitle fontSty",
              attrs: {
                slot: "title",
                title: _vm.menuTitleShow ? _vm.title : ""
              },
              slot: "title"
            },
            [_vm._v(_vm._s(_vm.title))]
          )
        : _c(
            "span",
            {
              ref: "menuTitle",
              staticClass: "line menutitle ",
              attrs: { slot: "title", title: _vm.titleShow ? _vm.title : "" },
              slot: "title"
            },
            [_vm._v(_vm._s(_vm.title))]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }